export const PROD_URL = 'seqsense.bio-rad.com'
export const MAXTAGLIMIT = "19"; 
export const seqUserGroup = "seqsenseuser";